$(function() {

	$('.infinity-loader-button').on('click', function(event) {
		if (!$(this).hasClass('loading')) {
			$(this).addClass('loading');
			ajaxInfinityLoader($(this));
		}
	});

});